import React from 'react';

export const PartnersMap = () => {
  // Partner locations with approximate coordinates (percentage positions on the map)
  const locations = [
    // Cayman Islands (Caribbean - northwest of Jamaica, south of Cuba)
    { name: 'Cayman Islands', x: 30, y: 51.5, count: 15 },
    
    // North America
    { name: 'Fort Lauderdale, USA', x: 22, y: 48, count: 1 },
    
    // Central & South America
    { name: 'Costa Rica', x: 20, y: 52, count: 1 },
    { name: 'Panama', x: 21, y: 53, count: 1 },
    { name: 'Dominican Republic', x: 26, y: 43.5, count: 1 },
    
    // Europe
    { name: 'United Kingdom', x: 45, y: 38, count: 2 },
    { name: 'Ireland', x: 44, y: 37, count: 1 },
    { name: 'Portugal', x: 45, y: 48, count: 1 },
    { name: 'Germany & Switzerland', x: 50, y: 38, count: 1 },
    
    // Middle East & Africa
    { name: 'United Arab Emirates', x: 59, y: 47, count: 1 },
    { name: 'South Africa', x: 52, y: 72, count: 1 },
    
    // Asia & Oceania
    { name: 'Thailand', x: 70, y: 50, count: 1 },
    { name: 'Philippines', x: 75, y: 51, count: 1 },
    { name: 'New Zealand', x: 88, y: 77, count: 1 },
  ];

  return (
    <div className="py-16 bg-gradient-to-b from-background to-muted/30">
      <div className="container mx-auto px-4 sm:px-6 lg:px-8">
        <div className="max-w-6xl mx-auto">
          {/* Header */}
          <div className="text-center mb-12">
            <h3 className="text-2xl sm:text-3xl font-bold text-foreground mb-4">
              Global Partner Network
            </h3>
            <p className="text-base sm:text-lg text-foreground/70 max-w-2xl mx-auto">
              Our trusted partners span across continents, ensuring seamless pet travel worldwide
            </p>
          </div>

          {/* Map Container */}
          <div className="relative w-full bg-white rounded-2xl shadow-xl p-6 sm:p-8">
            <div className="relative w-full" style={{ paddingBottom: '56.25%' }}>
              {/* World Map Image */}
              <img 
                src="/world-map.png" 
                alt="World map showing partner locations" 
                className="absolute inset-0 w-full h-full object-contain"
              />
              
              {/* Location Markers - Sharp Pin Style */}
              {locations.map((location, index) => (
                <div
                  key={index}
                  className="absolute group"
                  style={{
                    left: `${location.x}%`,
                    top: `${location.y}%`,
                    transform: 'translate(-50%, -50%)'
                  }}
                >
                  {/* Sharp Pin Marker */}
                  <div className="relative flex items-center justify-center">
                    {/* Pin Circle */}
                    <div className="w-3 h-3 sm:w-4 sm:h-4 bg-black rounded-full border-2 border-white shadow-lg cursor-pointer hover:scale-125 transition-transform relative z-10">
                      {/* Inner highlight for depth */}
                      <div className="absolute inset-0.5 bg-gradient-to-br from-gray-700 to-black rounded-full"></div>
                    </div>
                    
                    {/* Count Badge (only for locations with multiple partners) */}
                    {location.count > 1 && (
                      <div className="absolute -top-2 -right-2 bg-primary text-white text-xs font-bold rounded-full w-5 h-5 sm:w-6 sm:h-6 flex items-center justify-center border-2 border-white shadow-md z-20">
                        {location.count}
                      </div>
                    )}
                  </div>
                  
                  {/* Tooltip */}
                  <div className="absolute bottom-full left-1/2 -translate-x-1/2 mb-3 opacity-0 group-hover:opacity-100 transition-opacity pointer-events-none z-30">
                    <div className="bg-gray-900 text-white text-xs sm:text-sm px-3 py-2 rounded-lg whitespace-nowrap shadow-xl border border-gray-700">
                      <div className="font-semibold">{location.name}</div>
                      <div className="text-gray-300 text-xs">{location.count} {location.count === 1 ? 'Partner' : 'Partners'}</div>
                      {/* Arrow */}
                      <div className="absolute top-full left-1/2 -translate-x-1/2 -mt-px">
                        <div className="border-4 border-transparent border-t-gray-900"></div>
                      </div>
                    </div>
                  </div>
                </div>
              ))}
            </div>

            {/* Legend */}
            <div className="mt-6 flex flex-wrap items-center justify-center gap-6 text-sm text-foreground/70">
              <div className="flex items-center gap-2">
                <div className="w-3 h-3 bg-black rounded-full border-2 border-white shadow-md"></div>
                <span>Partner Location</span>
              </div>
              <div className="flex items-center gap-2">
                <div className="relative">
                  <div className="w-3 h-3 bg-black rounded-full border-2 border-white shadow-md"></div>
                  <div className="absolute -top-1.5 -right-1.5 bg-primary text-white text-xs font-bold rounded-full w-4 h-4 flex items-center justify-center border border-white">
                    #
                  </div>
                </div>
                <span>Multiple Partners</span>
              </div>
            </div>
          </div>

          {/* Stats */}
          <div className="mt-8 grid grid-cols-2 sm:grid-cols-4 gap-4">
            <div className="bg-white rounded-xl p-4 text-center shadow-md">
              <div className="text-3xl font-bold text-primary">14</div>
              <div className="text-sm text-foreground/70 mt-1">Countries</div>
            </div>
            <div className="bg-white rounded-xl p-4 text-center shadow-md">
              <div className="text-3xl font-bold text-primary">29</div>
              <div className="text-sm text-foreground/70 mt-1">Partners</div>
            </div>
            <div className="bg-white rounded-xl p-4 text-center shadow-md">
              <div className="text-3xl font-bold text-primary">6</div>
              <div className="text-sm text-foreground/70 mt-1">Continents</div>
            </div>
            <div className="bg-white rounded-xl p-4 text-center shadow-md">
              <div className="text-3xl font-bold text-primary">15</div>
              <div className="text-sm text-foreground/70 mt-1">Local Partners</div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};
